import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {getTicketNameForLogging} from '../../../domain/buy/ticket/util/getTicketNameForLogging';
import {Maybe, TicketType} from '../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {ButtonV2Variant} from '../../atoms/ButtonV2/ButtonV2.enum';
import {Dialog} from '../Dialog';

export interface TicketAskOwnTicketUseDialogProps {
  isMobile: boolean;
  productId: number;
  ticketOwnCount: number;
  ticketOwnType: Maybe<TicketType>;
  nonstopWatching?: boolean;
  onClickCancel: () => void;
  onClickConfirm: () => void;
  isShortsDrama?: boolean;
}

export function TicketAskOwnTicketUseDialog({
  isMobile,
  productId,
  nonstopWatching,
  ticketOwnCount,
  ticketOwnType,
  onClickCancel,
  onClickConfirm,
  isShortsDrama,
}: TicketAskOwnTicketUseDialogProps) {
  return (
    <Dialog
      isOpen={true}
      onClose={onClickCancel}
      isUsingScrollBlock={false}
      isMobile={isMobile}
      {...putTiaraObjectProps({
        click: {
          layer1: '소장권사용확인팝업',
          imp_id: 'popup',
          imp_provider: 'service',
        },
        viewimp_contents: {
          layer1: '소장권사용확인팝업',
          imp_id: 'popup',
          imp_provider: 'service',
          imp_type: 'vimp',
        },
        customProps: {
          popup_type: '소장권사용확인팝업',
          event_episode_id: String(productId),
          ...(nonstopWatching !== undefined
            ? {
                viewer_mode: nonstopWatching ? '정주행모드' : '일반모드',
              }
            : {}),
          ...(isShortsDrama && {
            is_shortdrama: isShortsDrama ? 'y' : undefined,
          }),
        },
      })}
      onInView={target => {
        aggregateAndSendLog({
          targetElem: target as HTMLElement,
          actionType: 'ViewImp',
          actionName: '팝업_노출',
          customProps: {
            user_action: 'imp',
            ...(isShortsDrama && {
              is_shortdrama: isShortsDrama ? 'y' : undefined,
            }),
          },
        });
      }}
    >
      <Dialog.Dimmed />
      <Dialog.Title>{t('ticketused_possession_popup')}</Dialog.Title>
      <Dialog.List>
        <Dialog.Label>
          {t('ticketused_possession_popup_ticket_balance', {
            values: {
              value: formatWithCommas(ticketOwnCount || 0),
            },
          })}
        </Dialog.Label>
      </Dialog.List>
      <Dialog.BottomCombination>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('소장권사용팝업_취소_클릭', e, onClickCancel)
          }
        >
          {t('common_cancel_button')}
        </Dialog.Button>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('소장권사용팝업_확인_클릭', e, onClickConfirm)
          }
          {...putTiaraObjectProps({
            customProps: {
              event_ticket_type: `소장_${
                ticketOwnType
                  ? getTicketNameForLogging(ticketOwnType)
                  : '소장권'
              }`,
            },
          })}
          variant={ButtonV2Variant.Primary}
        >
          {t('common_confirm_button')}
        </Dialog.Button>
      </Dialog.BottomCombination>
    </Dialog>
  );
}
